import { ColorToken } from '../designSystem/colors/colors';
import { Tier, TIERS } from '../models/careerPath';
import { CareerTrack } from '../models/careerTrack';

/**
 * Color mapping for career tracks by their display names
 */
export const CAREER_TRACK_COLORS: Record<CareerTrack['name'] | 'Unskilled', ColorToken> = {
  'Semi-skilled': 'Colors/Base/Black',
  'Trades/Technical': 'Colors/Foreground/fg-success-secondary',
  'Middle-Tier': 'Error/400',
  'Upper-Tier': 'Warning/400',
  'Top-Tier': 'Colors/Background/bg-brand-solid',
  Entrepreneurship: 'Colors/Background/bg-brand-solid',
  Unskilled: 'Gray/500',
} as const;

/**
 * Color mapping for career track tiers by their tier keys
 * Maps TIERS keys to the corresponding CareerTrack names in CAREER_TRACK_COLORS
 */
export const TIER_KEY_TO_COLOR: Record<string, ColorToken> = {
  SEMISKILLED: CAREER_TRACK_COLORS['Semi-skilled'],
  TRADE: CAREER_TRACK_COLORS['Trades/Technical'],
  MID: CAREER_TRACK_COLORS['Middle-Tier'],
  UPPER: CAREER_TRACK_COLORS['Upper-Tier'],
  TOP: CAREER_TRACK_COLORS['Top-Tier'],
  ENTREPRENEURSHIP: CAREER_TRACK_COLORS['Entrepreneurship'],
} as const;

/**
 * Mapping from tier values to colors
 */
export const TIER_TO_COLOR: Record<Tier, ColorToken> = {
  [TIERS.SEMISKILLED]: CAREER_TRACK_COLORS['Semi-skilled'],
  [TIERS.TRADE]: CAREER_TRACK_COLORS['Trades/Technical'],
  [TIERS.MID]: CAREER_TRACK_COLORS['Middle-Tier'],
  [TIERS.UPPER]: CAREER_TRACK_COLORS['Upper-Tier'],
  [TIERS.TOP]: CAREER_TRACK_COLORS['Top-Tier'],
  [TIERS.ENTREPRENEURSHIP]: CAREER_TRACK_COLORS['Entrepreneurship'],
} as const;
